import React from 'react';
import { Link } from 'react-router-dom';
import { Tab, Nav } from 'react-bootstrap';
import coachDeadlift from '../assets/images/about-coach-deadlift.jpeg';
import coachPortrait from '../assets/images/about-coach-portrait.jpeg';
import { useLanguage } from '../i18n/LanguageContext';

const FitnessGoal = ({ isOpenModal }) => {
  const { t } = useLanguage();
  return (
    <>
      <div className="col-lg-6 about-content m-b30">
        <div className="section-head m-0">
          <span className="sub-title">{t("ABOUT HYBRID PERFORMANCE ACADEMY")}</span>
          <h2 className="title">
            {t("Train Smarter, Perform Better")}
          </h2>
          <p className="m-0">{t("Hybrid Performance Academy is a digital training platform designed to remove confusion from strength and performance training through structured, science-based online education.")}</p>
        </div>

        <div className="" data-wow-delay="0.8s">
          <Tab.Container defaultActiveKey={'Mission'}>
            <Nav as="ul" className="nav nav-tabs style-1 m-b20 m-t30">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey={'Mission'}>
                  <span>{t("Our Mission")}</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey={'Vision'}>
                  <span>{t("Our Vision")}</span>
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content className="tab-content m-sm-b30 m-b40 p-r30" id="myTabContent">
              <Tab.Pane eventKey={'Mission'}>
                <div className="content">
                  <p>{t("Our mission is to provide athletes, coaches, and fitness enthusiasts with clear, practical, and progressive online training content. We focus on strength, conditioning, and performance principles that actually work — without trends, hype, or guesswork.")}</p>
                </div>
              </Tab.Pane>

              <Tab.Pane eventKey={'Vision'}>
                <div className="content">
                  <p>{t("Our vision is to become a trusted global platform for hybrid performance education, where users can access high-quality video libraries, structured programs, and intelligent recommendations tailored to their goals and subscriptions.")}</p>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <div className="contact-us">
          <span className="icon">
            <i className="fa-solid fa-headset"></i>
          </span>
          <div className="content">
            <span>{t("Need guidance?")}</span>
            <h4 className="number">{t("Online Support Available")}</h4>
          </div>
        </div>
      </div>

      <div className="col-lg-6 m-b30">
        <div className="hpa-platform-gallery">
          <figure className="hpa-platform-card hpa-platform-card-action">
            <img
              src={coachDeadlift}
              alt="Hybrid Performance Academy coach deadlifting"
              className="hpa-platform-photo"
            />
            <figcaption>
              <i className="flaticon-athletics" aria-hidden="true"></i>
              {t("Performance in action")}
            </figcaption>
          </figure>

          <figure className="hpa-platform-card hpa-platform-card-portrait">
            <img
              src={coachPortrait}
              alt="Hybrid Performance Academy coach"
              className="hpa-platform-photo"
            />
            <figcaption>
              <i className="flaticon-check-mark" aria-hidden="true"></i>
              {t("Expert-led coaching")}
            </figcaption>
          </figure>
        </div>
        {isOpenModal && (
          <Link
            to="#"
            className="hpa-platform-video-link"
            onClick={(event) => {
              event.preventDefault();
              isOpenModal(true);
            }}
          >
            <i className="fa fa-play" aria-hidden="true" />
            {t("Explore on-demand training")}
          </Link>
        )}
      </div>
    </>
  );
};

export default FitnessGoal;
